/*global VeloxGridAndFormController, VeloxFormController*/
var upload = require("../../util/upload") ;


var callToActionController = new VeloxGridAndFormController("call_to_action", {
    grid : {
        directory: "views/callToAction",
        name: "callToActionGrid"
    },
    form : {
        directory: "views/callToAction",
        name: "callToActionForm",
        joinFetch : [
            { otherTable: "velox_binary", thisField: "cta_id", otherField: "table_uid", name: "binary", joinSearch: {table_name:"call_to_action"}}
        ]
    }
});


callToActionController.formController.prepareDataOnEnter = function(data, callback){
    VeloxFormController.prototype.prepareDataOnEnter.call(this, data, function(err, data){
        if(err){ return callback(err) ;}
        if(data && data.binary && data.binary.uid){
            this.api.readBinary.url(data.binary, function(err, url){
                if(err){ return callback(err) ;}
                data.imageUrl = url ;
                callback(null, data) ;
            }) ;
        }else{
            callback(null, data) ;
        }
    }.bind(this)) ;
} ;


callToActionController.formController.getRecordsToDelete = function(record, callback){
    callback(null, [
        {action : "removeWhere", table: "velox_binary", record:  {table_name:"call_to_action", table_uid: record.cta_id}}
    ]) ;
};

callToActionController.formController.onUpload = function(){
    upload({
        multiple: false, 
        accept: "image/jpeg,image/png",
        sizeLimit: 500000
    },function(file){
        if(!file){ return ;}
        this.view.longTask(function(done){
            var binaryRecord = {
                table_name: "call_to_action", 
                table_uid: this.data.cta_id, 
                mime_type: file.type,
                description : file.name,
                filename: "calltoaction.jpg"
            };
            if(this.data.binary){
                binaryRecord.uid = this.data.binary.uid ;
            }
            this.api.saveBinary(
            file,
            binaryRecord, function(err, binary){
                if(err){ return done(err) ;}
                this.data.binary = binary ;
                this.api.readBinary.url(binary, function(err, url){
                    if(err){ return done(err) ;}
                    if(url.indexOf("http") === 0){
                        url += "?refresh="+new Date().getTime() ;
                    }
                    this.data.imageUrl = url ;
                    this.view.render() ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this));
} ;


module.exports = callToActionController ;